import { render, staticRenderFns } from "./Listadopedido.vue?vue&type=template&id=2e3eb42e&scoped=true"
import script from "./Listadopedido.vue?vue&type=script&lang=js"
export * from "./Listadopedido.vue?vue&type=script&lang=js"
import style0 from "./Listadopedido.vue?vue&type=style&index=0&id=2e3eb42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3eb42e",
  null
  
)

export default component.exports